<template>
	<div class="live-schedule">
		
		<van-empty description="内容正在完善中..."  v-if="isempty"/>
		<div v-else>
			<div class="timeTabs-wrap" v-if="scheduleDate.length!=0">
				<div class="timeTabs">
					<div class="tab-item" v-for="(item,index) in scheduleDate" :key="index" @click="switchDate(item)" :class="item==active?'active':''">
						{{item}}
					</div>
				</div>			
			</div>
			<div class="content">
				<div v-for="(item,suffix) in scheduleList" :key="suffix">
					<div v-for="(value,index) in item" :key="index">
						<div class="scheduleHead">
							<h3 v-if="value.name">
								<img :src="value.image" alt="" v-if="value.image">
								<span v-if="path=='/meeting/schedule'">{{suffix}}</span> 
								{{value.name}} 
								
							</h3>
							<div class="attendee">
								<div class="expert">
									<span>{{value.start_at+' - '+ value.end_at}}</span>
								</div>
								<div class="host expert" v-if="value.host_writers.length>0">
									<div class="flexRow-center">
										<img src="@/assets/images/host.jpg" alt="">
										<span>主持专家: </span>
									</div>
									<p>
										<router-link :to="{path:'/expert/schedule',query:{meeting_id:meeting_id,writer_id:val.id}}" v-for="val in value.host_writers" :key="val.id">
											{{val.name}}
										</router-link>
									</p>
								</div>
								<div class="discussors expert" v-if="value.discussor_writers.length>0">
									<div class="flexRow-center">
										<img src="@/assets/images/disscuss.jpg" alt="">
										<span>讨论专家:</span>
									</div>
									<p>
										<router-link :to="{path:'/expert/schedule',query:{meeting_id:meeting_id,writer_id:val.id}}" v-for="val in value.discussor_writers" :key="val.id">
											{{val.name}}
										</router-link>
									</p>
								</div>
								<div>
									<div class="discussors expert" v-for="(val) in value.titles" :key="val.id">
										<div class="flexRow-center">
											<img src="@/assets/images/disscuss.jpg" alt="">
											<span>{{val.title}}:</span>
										</div>
										<p>
											<router-link :to="{path:'/expert/schedule',query:{meeting_id:meeting_id,writer_id:item.id}}" v-for="item in val.writers" :key="item.id">
												{{item.name}}
											</router-link>
										</p>
									</div>
								</div>					
							</div>
						</div>
						<div class="time-item" v-for="(val,ind) in value.details" :key="ind" :class="{'recorded':val.recordid,'playing':currentRecordid&&(val.recordid==currentRecordid)}"  @click="playRecorded(index,ind,value.session.id,val)">
							<div class="time">
								<van-icon name="clock-o" />
								<span>{{val.time}}</span>
							</div>
							<div class="introduction">
								<p class="title">{{val.name}}<span v-if="val.recordid">（已生成录播）</span></p>
								<p>
								<router-link :to="{path:'/expert/schedule',query:{meeting_id:meeting_id,writer_id:i.id}}" v-for="i in val.writers" :key="i.id">
								<!-- <p class="name" v-for="i in val.writers" :key="i.id"> -->
								<span :style="{'margin-bottom':i.company?'5px':'0px'}">{{i.name}}</span>
								<!-- </p> -->
								</router-link>
								</p>
								<p class="des" v-if="val.des">详情: {{val.des}}</p>
							</div>
							<div class="status">
								
							</div>
						</div>	
					</div>			
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	export default{
		props:['meetingSchedule'],
		data(){
			return{
				isempty:false,
				meeting_id:0,
				scheduleData:this.meetingSchedule,       //日程
				scheduleDate:Object.keys(this.meetingSchedule),   //日期
				scheduleList:[],       //日期对应的日程列表
				active:0,
				scrollTop:0,           //滚动距离
				selectedRecorded:this.$store.state.selectedRecorded,
				path:'',
				currentRecordid:this.$store.state.videoUrl
			}
		},
		watch:{
			//监测meetingSchedule
			meetingSchedule(newData,oldData){
					this.scheduleData=newData;
					this.isempty=!Object.keys(newData).length;
					this.scheduleDate=Object.keys(newData);
					this.switchDate(this.scheduleDate[0]);			
			},
			'$store.state.videoUrl'(newData){
				this.currentRecordid=newData
			}
		},
		mounted(){
			window.addEventListener('scroll', this.handleScroll);
			let url=this.$route.query.video_url?this.$route.query.video_url:'';
			this.path=this.$route.path;
			this.meeting_id=this.$route.query.meeting_id;
	
		},
		methods:{
			//切换日期
			switchDate(date){
				this.active=date;
				this.scheduleList=this.scheduleData[date];
				let key=Object.keys(this.scheduleList)[0];
				let scheduleList=this.scheduleList[key];
				scheduleList.forEach((item,index)=>{
					let startTime=(item['start_at'].split(' ')[1]).split(':');
					item.start_at=startTime[0]+':'+startTime[1];
					let endTime=(item['end_at'].split(' ')[1]).split(':');
					item.end_at=endTime[0]+':'+endTime[1];
				})
				this.scheduleList=this.scheduleList;
				this.$store.dispatch('receiveRecording',this.scheduleList)
			},
			//浏览器滚动
			handleScroll(){
				this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || 
  				document.body.scrollTop;
  				if(this.scrollTop>60){
  					// console.log(1212)
  				}
			},
			//播放录播
			playRecorded(suffix,index,id,value){
				this.$store.dispatch('receiveVideoUrl',value.recordid);
				if(value.recordid){	 
					//判断当前的路由
					let path=this.$route.path;
					if(path=='/meeting/schedule'){
						this.$router.push({
							path:'/meeting/live',
							query:{
								meeting_id:this.$route.query.id,
								id:id,
								video_url:value.recordid
							}
						})

					}
				}else{
					common.toast('暂无录播',1000)
				}

			},
		},
		destoryed(){
			 window.removeEventListener('scroll', this.handleScroll);
		}
	}
</script>
<style lang="scss">
	.live-schedule{
		.timeTabs-wrap{
			overflow:hidden;
			width:100%;
			background:#fff;
		
		}
		.fixed{
			position: fixed;
			top:0px;
			z-index:1000;
		}
		.timeTabs{
			padding:0 12px;
			height:60px;
			@include flex(row);
			align-items: center;
			overflow:auto;
			width:100%;
			border-bottom:1px solid #bfbfbf;
			.tab-item{
				font-size:14px;
				color:#666;
				width:70px;
				height:30px;
				text-align:center;
				line-height:30px;
				border:1px solid #666;
				border-radius:2px;
				margin-right:15px;
			}
			.active{
				color:#fff;
				background:$color-main;
				border:0px;
			}
		}
		.content{
			padding:0px 12px;
			.scheduleHead{
				border-bottom:1px solid #bfbfbf;
			}
			h3{
				margin-top:13px;
				font-size: 15px;
				color: #090909;
				letter-spacing: 0.53px;
				line-height: 25px;
				
				img{
					height:35px;
					transform: translate(0px,8px);
				}
			}
			.attendee{
				margin:10px 0;
				.expert{
					display: flex;
					img{width:18px;}
					span{
							margin-right:5px;
							color:#999;
						}
					p{
						flex:1;
						text-align: justify;
						font-size:12px;
						color:#999;
					}
				}

			}
			
			.time-item{
				padding:5px 0;
				@include flex(row);
				align-items:center;
				justify-content:space-between;
				.time{
					@include flex(row);
					align-items:center;
					padding:5px 8px;
					font-size:13px;
					color:#fff;
					background-color:$color-gray;
					border-radius:2px;
					i{
						font-size:15px;
						margin-right:5px;
					}
				}
				.introduction{
					flex:1;
					letter-spacing:.46px;
					margin-left:15px;
					.title{
						color:$color-black;
						font-size:13px;
						margin-bottom:10px;
						text-align: justify;
					}
					.name{
						font-size:11px;
						color:#666;
					}
					.des{
						font-size:13px;
						word-break: break-all;
						text-align: justify;
					}
					span{
						margin-right: 2px;

					}
				}
				.status{
					width:25px;
					height:15px;
					margin-left:15px;
					background-size:cover;
					background-position:center;
				}
			}
			.time-item:not(:last-child){
				border-bottom:1px solid #bfbfbf;
			}
			/*录播状态*/
			.recorded{
				.time{
					background-color:#204EA1;
				}
				.introduction{
					color:#204EA1;
					span{
						color:#3f3f3f;
						font-size:11px;
					}
					span{
						text-align: justify;
					}
				}
				.status{
					background-image:url(../../assets/images/Meeting/Meeting_recorded.png);
				}
			}

			/*正在直播状态*/
			.playing{
				.time{
					background-color:$color-main;
				}
				.introduction{
					color:$color-main;
					span{
						color:#3f3f3f;
						font-size:11px;
					}
				}
				.status{
					background-image:url(../../assets/images/Meeting/Meeting_live.png);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Meeting/Schedule.vue